import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

import { IonPage, IonContent, } from '@ionic/vue';
import StocktakingPlaceSelectionIndicator from '@/components/stocktaking/StocktakingPlaceSelectionIndicator.vue'
import StartStocktakingHeader from '@/components/stocktaking/headers/start-stocktaking/StartStocktakingHeader.vue'
import StartStocktakingArticleList from '@/components/stocktaking/article-list/start-stocktaking/StartStocktakingArticleList.vue'
import { BasicSliderButton, BasicAlertsList } from '@/components/basic';

import useScanner from '@/composable/useScanner';
import useCreateCensusSheetDocument from "./_inner/useCreateCensusSheetDocument";
import useSetupStartStocktakingAlerts from './_inner/useSetupStartStocktakingAlerts'
import { useRoute } from 'vue-router';


export default /*#__PURE__*/_defineComponent({
  __name: 'StartStockTakingDocumentView',
  setup(__props) {

const route = useRoute();
const id = Number(route.params.id);

const {
    articles, handleScan, selectedPlace, clearPlacements,
    changeArticleQuantity, deleteArticleQuantity, 
} = useCreateCensusSheetDocument(id);

const { alertConfigs, displayAlertHandlers } = useSetupStartStocktakingAlerts(
    id,
    articles,
    { changeArticleQuantity, deleteArticleQuantity }
);

useScanner({
    onScan(code) {
        handleScan(code);
    }
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonPage), null, {
    default: _withCtx(() => [
      _createVNode(_unref(BasicAlertsList), { alerts: _unref(alertConfigs) }, null, 8, ["alerts"]),
      _createVNode(StartStocktakingHeader, {
        "is-clear-placements-disabled": _unref(articles).length === 0,
        onOnClearPlacements: _unref(clearPlacements)
      }, null, 8, ["is-clear-placements-disabled", "onOnClearPlacements"]),
      _createVNode(_unref(IonContent), {
        fullscreen: true,
        class: "ion-padding"
      }, {
        default: _withCtx(() => [
          _createVNode(StocktakingPlaceSelectionIndicator, { "selected-place": _unref(selectedPlace) }, null, 8, ["selected-place"]),
          (_unref(selectedPlace))
            ? (_openBlock(), _createBlock(StartStocktakingArticleList, {
                key: 0,
                articles: _unref(articles),
                onOnOpenChangeQuantityAlert: _unref(displayAlertHandlers).openChangeQuantityAlert,
                onOnOpenDeleteSignleArticleAlert: _unref(displayAlertHandlers).openDeleteSingleArticleAlert
              }, null, 8, ["articles", "onOnOpenChangeQuantityAlert", "onOnOpenDeleteSignleArticleAlert"]))
            : _createCommentVNode("", true),
          _createVNode(_unref(BasicSliderButton), {
            onOnSuccess: _unref(displayAlertHandlers).openCloseDocumentAlert,
            size: 48
          }, null, 8, ["onOnSuccess"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})